<template>
  <div class="content">
    <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item class="buildItem">项目管理</el-breadcrumb-item>
      <el-breadcrumb-item>
        <a to="/">事项管理</a>
      </el-breadcrumb-item>
    </el-breadcrumb> -->
     <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>施工管理</el-breadcrumb-item>
            <el-breadcrumb-item>事项管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div class="build-CURD">
      <div class="build-bar">
        <el-col :span="12" style="text-align: left;padding-left: 20px;display: flex;">
          <el-button-group style="margin-right:10px;">
            <el-button class="head-type" :class="{headCur:head.timeType==1}" @click="changType(1)">日</el-button>
            <el-button class="head-type" :class="{headCur:head.timeType==2}" @click="changType(2)">周</el-button>
            <el-button class="head-type" :class="{headCur:head.timeType==3}" @click="changType(3)">月</el-button>
          </el-button-group>
          <el-date-picker
            v-if="head.timeType==1"
            v-model="head.time1"
            value-format="yyyy-MM-dd"
            type="date"
            @change="timeChange"
            placeholder="选择日期">
          </el-date-picker>
          <el-date-picker
            v-else-if="head.timeType==2"
            v-model="head.time2"
            value-format="yyyy-MM-dd"
            type="week"
            format="yyyy 第 WW 周"
            @change="timeChange"
            placeholder="选择周">
          </el-date-picker>
          <el-date-picker
            v-else-if="head.timeType==3"
            v-model="head.time3"
            value-format="yyyy-MM"
            type="month"
            @change="timeChange"
            placeholder="选择月">
          </el-date-picker>
        </el-col>
        <el-col :span="12" style="text-align: right;">
          <a style="color:#ffbc01">未处理 <p>{{num.wcl}}</p> </a>
          <a style="color:#36c635">已处理 <p>{{num.ycl}}</p> </a>
          <a style="color:#17b2fe">已确认 <p>{{num.ysh}}</p> </a>
          <a style="color:#f12b2c">已超时 <p>{{num.ycs}}</p> </a>
        </el-col>
      </div>
      <div class="build-table">
        <el-table :data="tableData" style="width: 100%">
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column label="序号">
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>
          <el-table-column label="巡检事项">
            <template slot-scope="scope">
              <span v-if="scope.row.priority==1">一般隐患</span>
              <span v-else-if="scope.row.priority==2">重大隐患</span>
              <span v-else>其他</span>
            </template>
          </el-table-column>
          <el-table-column label="巡检人">
            <template slot-scope="scope">
              <span>{{ scope.row.reportName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="巡检时间">
            <template slot-scope="scope">
              <span>{{ scope.row.reportDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="内容">
            <template slot-scope="scope">
              <span>{{ scope.row.description }}人</span>
            </template>
          </el-table-column>
          <el-table-column label="处理人">
            <template slot-scope="scope">
              <span>{{ scope.row.handlerName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status==0" style="color:#FFBC01;">待处理</span>
              <span v-else-if="scope.row.status==1">处理中</span>
              <span v-else-if="scope.row.status==2" style="color:#0085FF;">待确认</span>
              <span v-else style="color:#36C635;">已确认</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页展示 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[3, 5, 10,20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import myHttp from "../../untils/port.js";
import util from "../../untils/util.js"
import base from '../../untils/base'
export default {
  data() {
    return {
      head:{
        timeType:1,//时间类型  1：日    2：周    3：月
        time1:util.myTime.getCurTime(),
        time2:util.myTime.getWeekDay(0),
        time3:util.myTime.getCurMonth(),
        startDate:'',
        endDate:'',
        flag:'',
      },
      num:{
        wcl:0,
        ycl:0,
        ysh:0,
        ycs:0
      },
      tableData:[],//获取数据
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      projectId:'',
      dataText:"数据加载中...",
    }
  },
  mounted(){
    this.projectId = this.$store.state.groupId;
    if(this.projectId==""){
      this.$store.commit("setGroupId");
      this.projectId = this.$store.state.groupId;
    }
    this.getData();
  },
  methods: {
    //获取数量
    getNum(){
      var that = this;
      myHttp.getQsStatusCount({
        projectId:this.projectId,
        type:'3',
        startTime:this.head.startDate,
        endTime:this.head.endDate,
      }).then(function(resp){
        if(resp.data.code=="200"){
          that.num = resp.data.data.statusCount||that.num;
        }
      });
    },
    //时间类型修改
    changType(index){
      if(this.head.timeType != index){
        this.head.timeType = index;
        this.getData();
      }
    },
    //时间改变
    timeChange(){
      this.getData();
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage();
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData();
    },
    //获取数据
    getData(){
      if(this.head.timeType==1){
        this.head.startDate = this.head.time1;
        this.head.endDate = this.head.time1;
      }else if(this.head.timeType==2){
        this.head.startDate = this.head.time2;
        this.head.endDate = util.myTime.getWeekDay(6,this.head.time2);
      }else if(this.head.timeType==3){
        this.head.startDate = this.head.time3+'-01';
        var day = new Date(parseInt(this.head.time3.split('-')[0]),parseInt(this.head.time3.split('-')[1]),0).getDate();
        this.head.endDate = this.head.time3+'-'+day;
      }
      this.getNum();
      var that = this;
      myHttp.findQsPageList({
        projectId:this.projectId,
        type:'3',
        startTime:this.head.startDate,
        endTime:this.head.endDate,
        flag:'',
        pageSize:this.pageSize,
        pageNum:this.currentPage
      }).then(function(resp){
        if(resp.data.code=="200"){
          var list = resp.data.data.pageInfo.list||[];
          for(var i=0;i<list.length;i++){
              list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
            }
          that.tableData = list;
          that.totalItems = resp.data.data.pageInfo.total||0;
          if(that.tableData.length==0){
              that.dataText='暂无数据'
            }
        }else{
          that.$message.error(resp.data.msg);
          that.dataText='暂无数据'
        }
      });
    },
    // 编辑数据
    handleEdit(index, row) {
      this.$router.push({name: "qsDetail", params: {'id': row.id}});
    },
  }
}
</script>

<style scoped>
/* * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
} */
.content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  /* background: #fff; */
}
.el-breadcrumb {
  line-height: 30px;
  margin-bottom: 20px;
}
.buildItem {
  font-weight: 0;
  font-size: 24px;
}
.build-CURD {
  height: 100%;
  background-color: #fff;
}
.build-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 80px;
  border-top: 3px solid rgb(224, 224, 224);
  border-bottom: 3px solid #17b2fe;
}
.build-bar span {
  margin-left: 30px;
  margin-right: 20px;
  white-space: nowrap;
  font-weight: bold;
}
.build-bar a {
  display: inline-block;
  white-space: nowrap;
  font-size: 17px;
}
.build-bar a p {
  display: inline-block;
  margin-left: 10px;
  margin-right: 40px;
}
.build-bar > .el-input {
  margin-left: 50px;
  width: 400px;
}
.build-bar > .el-button {
  margin-left: 20px;
  background-color: #17b2fe;
  border-color: #17b2fe;
}
.build-bar > .el-button + .el-button {
  margin-left: 800px;
}
.el-select .el-input {
  width: 130px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.build-table {
  position: relative;
  width: 94%;
  margin: 0 auto;
  height: calc( 100% - 160px );
}
.el-table .el-table-column:not(:first-child) {
  border: 1px solid slategrey;
}
.el-table >>> .cell {
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}
.el-dialog {
  width: 400px;
}
.el-pagination {
  padding: 20px 0;
}
.head-type{
  color: #17b2fe;
}
.el-button-group>.headCur{
  color: #fff;
  background: #17b2fe;
}
</style>